// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4QBY1","badges":"styles_badges__1-iXx"};